/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import axios from "axios";
import { devLog } from "@/utils/devLog";

/**
 * Charge la liste des radios depuis le backend une fois.
 * Renvoie { radios, error }.
 */
export function useRadios(apiBase) {
  const [radios, setRadios] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${apiBase}/radios`)
      .then((r) => {
        if (!cancelled) setRadios(r.data.radios || []);
      })
      .catch((e) => {
        if (!cancelled) {
          setError(e);
          devLog("Failed to load radios", e);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [apiBase]);

  return { radios, error };
}
